import React from 'react';
import { Navbar } from '../../components/navbar';
import { Footer } from '../../components/footer';

import Edita_book_cover from '../../assets/images/Edita-Foods-Book-Cover.png'
import edita_logo from '../../assets/images/edita-logo.png';

import '../page-style.css'
import { useNavigate } from 'react-router-dom';
import Edita_Final from '../../assets/downloads/Edita-Final-Case.pdf';

import {BsArrowLeft} from 'react-icons/bs';
const P1 = "Established in 1996, Edita Food Industries has since grown to become a leader in the Egyptian and regional snack food markets."
const P2 = "Building an Empire, One Snack at a time,consistently introducing new product propositions to best match consumers’ evolving tastes."
// const P3 = "Building an Empire, One Snack at a time,consistently introducing new product propositions to best match consumers’ evolving tastes."

export const EDITA = () => {
    const navigate = useNavigate();
    const handleEnter = ()=>{
        navigate("/case-studies")
    }

    const onButtonClick = (typeOfCase) => {
        fetch(typeOfCase).then(response => {
            response.blob().then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = typeOfCase;
                alink.click();
            })
        })
    }
    return (
        <div className={'main'}>
            <Navbar whiteText={false} className={'home-navbar'} />
            <div className='section-Study'>      
                <div className='study-img-card'>
                    <img src={edita_logo} alt={'ubi'} className='ubi-enegry-image' /> 
                    <div className='ubi-text'>
                        Edita Foods Industry
                    </div>
                    <div className= 'casestudy-text'> {P1}</div> 
                </div>

                <div className='card'>
                    <div className='study-container study-card'>
                        <img className='book-pic' alt='book-pic' src={Edita_book_cover} />
                        <h1 className='case-study-header'>
                            Edita: Full case study</h1>
                        <p className='case-page-text partner-text'>
                            {P2}
                        </p>
                        <button className='download-casestudy hover-green' onClick={() => onButtonClick(Edita_Final)}>Download full case study</button>
                    </div>
                    
                    
                </div>
            </div>

           <div className='section-stats'>
            <div className='stat'>
                <h1 className='stat-header'>
                     1966
                </h1>
                <p1 className="stat-text">
                     Year founded
                </p1>
            </div>
            <div className='stat'>
                <h1 className='stat-header'>
                    25 
                </h1>
                <p1 className = "stat-text">
                    Distribution centers
                </p1>
            </div>
            <div className='stat'>
                <h1 className='stat-header'>
                    3 billion pouches
                </h1>
                <p1 className="stat-text" >
                     Edita has cemented its reputation for quality and innovation both in Egypt and abroad.
                </p1>
            </div>
           </div>
           <div className='doc'>
                <h1 className='doc-text'>Watch the documentary</h1>
            </div>
            <div className='vid-frame videoWrapper'>
               <iframe className='yt-vid' width="1450" height="815" src="https://www.youtube.com/embed/8cG5BHQW8iE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture & muted=1" allowfullscreen></iframe>
            </div>
            <div className='back-to-casestudy'>
                 <button className="btn btn-back-to-casestudy" onClick={handleEnter}>
                    <div className='back-btns'>
                        <BsArrowLeft className='arrow'/>
                        <div className='back-text'>
                            Back to casestudy
                        </div>
                    </div>
                    </button>
            </div>
            <Footer />
        </div>
    )
}